<template>
  <div class="cartelera-page">
    <div class="container">

      <!-- Header -->
      <div class="festival-header">
        <span class="programa-label">Programa Febrero - Marzo</span>
        <h1 class="festival-title">Festival Arena y Barro</h1>
        <span class="aniversario">30 años</span>
      </div>

      <!-- Espectáculos Grid -->
      <div class="espectaculos-grid">

        <template v-for="show in festivalShows" :key="show.id">

          <!-- Linked shows (have detail page) and NOT passed -->
          <router-link
            v-if="show.link && !isPast(show.date)"
            :to="show.link"
            class="espectaculo-card espectaculo-link"
            :class="{ 'espectaculo-special': show.special }"
          >
            <div class="venue-badge" :class="show.venue">{{ show.venue }}</div>
            <span class="entradas-badge">🎟️ Entradas</span>
            <div class="fecha">{{ show.fechaDisplay }}</div>
            <h3 class="titulo">{{ show.titulo }} <span v-if="show.origen" class="origen">- {{ show.origen }}</span></h3>
            <template v-if="show.subShows">
              <div class="sub-shows">
                <div v-for="sub in show.subShows" :key="sub.time" class="sub-show">
                  <span class="sub-time">{{ sub.time }}</span>
                  <span class="sub-name">{{ sub.name }} <span v-if="sub.origen" class="origen">- {{ sub.origen }}</span></span>
                </div>
              </div>
            </template>
            <p class="categoria">{{ show.categoria }}</p>
            <span class="ver-mas">Ver más →</span>
          </router-link>

          <!-- Non-linked shows OR passed shows -->
          <div
            v-else
            class="espectaculo-card"
            :class="{
              'espectaculo-special': show.special,
              'espectaculo-passed': isPast(show.date)
            }"
          >
            <div class="venue-badge" :class="show.venue">{{ show.venue }}</div>
            <div v-if="isPast(show.date)" class="passed-badge">Finalizado</div>
            <span v-else class="entradas-badge">🎟️ Entradas</span>
            <div class="fecha">{{ show.fechaDisplay }}</div>
            <h3 class="titulo">{{ show.titulo }} <span v-if="show.origen" class="origen">- {{ show.origen }}</span></h3>
            <template v-if="show.subShows">
              <div class="sub-shows">
                <div v-for="sub in show.subShows" :key="sub.time" class="sub-show">
                  <span class="sub-time">{{ sub.time }}</span>
                  <span class="sub-name">{{ sub.name }} <span v-if="sub.origen" class="origen">- {{ sub.origen }}</span></span>
                </div>
              </div>
            </template>
            <p class="categoria">{{ show.categoria }}</p>
          </div>

        </template>

      </div>

      <!-- Próximas Funciones (fuera del festival) -->
      <div v-if="otherShows.length > 0" class="proximas-section">
        <div class="proximas-header">
          <h2 class="proximas-title">Próximas funciones</h2>
        </div>

        <div class="espectaculos-grid">
          <template v-for="show in otherShows" :key="show.id">
            <router-link
              v-if="show.link && !isPast(show.date)"
              :to="show.link"
              class="espectaculo-card espectaculo-link"
            >
              <div class="venue-badge" :class="show.venue">{{ show.venue }}</div>
              <span class="entradas-badge">🎟️ Entradas</span>
              <div class="fecha">{{ show.fechaDisplay }}</div>
              <h3 class="titulo">{{ show.titulo }} <span v-if="show.origen" class="origen">- {{ show.origen }}</span></h3>
              <p class="categoria">{{ show.categoria }}</p>
              <span class="ver-mas">Ver más →</span>
            </router-link>

            <div
              v-else
              class="espectaculo-card"
              :class="{ 'espectaculo-passed': isPast(show.date) }"
            >
              <div class="venue-badge" :class="show.venue">{{ show.venue }}</div>
              <div v-if="isPast(show.date)" class="passed-badge">Finalizado</div>
              <span v-else class="entradas-badge">🎟️ Entradas</span>
              <div class="fecha">{{ show.fechaDisplay }}</div>
              <h3 class="titulo">{{ show.titulo }} <span v-if="show.origen" class="origen">- {{ show.origen }}</span></h3>
              <p class="categoria">{{ show.categoria }}</p>
            </div>
          </template>
        </div>
      </div>

      <!-- Venue Legend -->
      <div class="venue-legend">
        <div class="legend-item">
          <span class="legend-badge playa">Playa</span>
          <a href="https://maps.app.goo.gl/b1CQ3BuSKiwiXD5N8" target="_blank" rel="noopener" class="legend-link">
            Espectáculos en la playa (Rambla: Bajada 30)
            <span class="map-icon">📍</span>
          </a>
        </div>
        <div class="legend-item">
          <span class="legend-badge sala">Sala</span>
          <a href="https://maps.app.goo.gl/kQL5XygdunFnacNf9" target="_blank" rel="noopener" class="legend-link">
            Espectáculos en sala (Teatro Babilonia - El Pinar)
            <span class="map-icon">📍</span>
          </a>
        </div>
      </div>

      <!-- Contact CTA -->
      <div class="contact-cta">
        <p class="contact-text">Por más información de costos de espectáculos y talleres</p>
        <a href="https://wa.me/59899409402" target="_blank" rel="noopener" class="contact-btn">
          <span class="whatsapp-icon">📱</span>
          Escribinos por privado
        </a>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'CarteleraPage',
  data() {
    return {
      espectaculos: [
        {
          id: 1,
          titulo: 'Ernesto Díaz & Fabián Severo',
          origen: null,
          venue: 'playa',
          date: '2026-02-13',
          fechaDisplay: 'Viernes 13 de Febrero - 21:00 h',
          categoria: 'Música',
          link: '/funcion/4',
          special: false
        },
        {
          id: 2,
          titulo: 'El Quijote Popular',
          origen: 'Chile',
          venue: 'sala',
          date: '2026-02-14',
          fechaDisplay: 'Sábado 14 de Febrero - 21:00 h',
          categoria: 'Teatro',
          link: '/funcion/1',
          special: false
        },
        {
          id: 3,
          titulo: '8 Espejos',
          origen: 'Grupo Babilonia',
          venue: 'sala',
          date: '2026-02-20',
          fechaDisplay: 'Viernes 20 de Febrero - 21:00 h',
          categoria: 'Teatro',
          link: '/funcion/2',
          special: false
        },
        {
          id: 4,
          titulo: 'La Loca del Bequeló',
          origen: 'Pequeño Teatro de Durazno',
          venue: 'playa',
          date: '2026-02-21',
          fechaDisplay: 'Sábado 21 de Febrero - 21:00 h',
          categoria: 'Teatro',
          link: '/funcion/3',
          special: false
        },
        {
          id: 5,
          titulo: 'Buceo Invisible',
          origen: null,
          venue: 'playa',
          date: '2026-02-27',
          fechaDisplay: 'Viernes 27 de Febrero - 21:00 h',
          categoria: 'Música',
          link: '/funcion/5',
          special: false
        },
        {
          id: 6,
          titulo: 'Noche de Circo',
          origen: null,
          venue: 'sala',
          date: '2026-02-28',
          fechaDisplay: 'Sábado 28 de Febrero - 19:00 a 22:00 h',
          categoria: 'Circo',
          link: '/funcion/6',
          special: true,
          subShows: [
            { time: '19 h', name: '¿Dónde estoy? ¿Quién Soy? ¿Para dónde voy?', origen: 'Brasil' },
            { time: '21 h', name: 'La Silueta del Circo', origen: 'Uruguay' }
          ]
        },
        {
          id: 7,
          titulo: 'Tercer Fuerxa',
          origen: null,
          venue: 'sala',
          date: '2026-03-06',
          fechaDisplay: 'Viernes 06 de Marzo - 21:00 h',
          categoria: 'Danza',
          link: '/funcion/7',
          special: false
        },
        {
          id: 8,
          titulo: 'Por culpa de la E',
          origen: 'Sin Fogón Fray Bentos',
          venue: 'sala',
          date: '2026-03-07',
          fechaDisplay: 'Sábado 07 de Marzo - 21:00 h',
          categoria: 'Teatro',
          link: '/funcion/8',
          special: false
        },
        {
          id: 9,
          titulo: 'Naipe Marcado Trío Tango',
          origen: null,
          venue: 'sala',
          date: '2026-03-08',
          fechaDisplay: 'Domingo 08 de Marzo - 20:00 h',
          categoria: 'Música',
          link: '/funcion/9',
          special: false
        },
        {
          id: 10,
          titulo: 'Orquesta Subtropical',
          origen: null,
          venue: 'sala',
          date: '2026-03-20',
          fechaDisplay: 'Viernes 20 de Marzo - 21:00 h',
          categoria: 'Música',
          link: '/funcion/10',
          festival: false
        },
        {
          id: 11,
          titulo: '8 Espejos',
          origen: 'Grupo Babilonia',
          venue: 'sala',
          date: '2026-03-21',
          fechaDisplay: 'Sábado 21 de Marzo - 21:00 h',
          categoria: 'Teatro',
          link: '/funcion/11',
          special: false,
          festival: false
        },
        {
          id: 12,
          titulo: '8 Espejos',
          origen: 'Grupo Babilonia',
          venue: 'sala',
          date: '2026-03-27',
          fechaDisplay: 'Viernes 27 de Marzo - 21:00 h',
          categoria: 'Teatro',
          link: '/funcion/12',
          special: false,
          festival: false
        }
      ]
    }
  },
  methods: {
    isPast(dateStr) {
      const showDate = new Date(dateStr + 'T23:59:59');
      const today = new Date();
      return showDate < today;
    }
  },
  computed: {
    festivalShows() {
      return this.espectaculos.filter(s => s.festival !== false)
    },
    otherShows() {
      return this.espectaculos.filter(s => s.festival === false)
    }
  }
}
</script>

<style scoped>
.cartelera-page {
  background: #000;
  padding: 60px 0 80px;
  min-height: 50vh;
}

.container {
  max-width: 950px;
  margin: 0 auto;
  padding: 0 20px;
}

/* Festival Header */
.festival-header {
  text-align: center;
  margin-bottom: 50px;
}

.programa-label {
  display: block;
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 0.2em;
  color: #c9a227;
  margin-bottom: 10px;
}

.festival-title {
  font-size: 42px;
  font-weight: bold;
  color: #fff;
  margin: 0 0 10px 0;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.aniversario {
  display: inline-block;
  font-size: 18px;
  color: #c9a227;
  font-style: italic;
}

/* Espectáculos Grid */
.espectaculos-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 25px;
  margin-bottom: 50px;
}

/* Espectáculo Card */
.espectaculo-card {
  position: relative;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid #333;
  border-radius: 10px;
  padding: 25px;
  transition: all 0.3s ease;
}

.espectaculo-card:hover {
  border-color: #c9a227;
  background: rgba(201, 162, 39, 0.05);
}

/* Passed shows */
.espectaculo-passed {
  opacity: 0.5;
  filter: grayscale(50%);
}

.espectaculo-passed:hover {
  border-color: #333;
  background: rgba(255, 255, 255, 0.03);
  opacity: 0.5;
}

.passed-badge {
  position: absolute;
  top: 15px;
  right: 15px;
  background: #666;
  color: #fff;
  font-size: 11px;
  font-weight: bold;
  padding: 4px 10px;
  border-radius: 3px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.entradas-badge {
  position: absolute;
  top: 15px;
  right: 15px;
  background: #27ae60;
  color: #fff;
  font-size: 12px;
  font-weight: bold;
  padding: 5px 12px;
  border-radius: 4px;
  text-decoration: none;
  letter-spacing: 0.03em;
  z-index: 2;
}

/* Linked cards */
.espectaculo-link {
  text-decoration: none;
  display: block;
  cursor: pointer;
}

.espectaculo-link:hover {
  transform: translateY(-3px);
}

.ver-mas {
  display: block;
  margin-top: 15px;
  font-size: 14px;
  font-weight: bold;
  color: #c9a227;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.espectaculo-link:hover .ver-mas {
  opacity: 1;
}

.espectaculo-special {
  grid-column: 1 / -1;
  background: rgba(201, 162, 39, 0.08);
  border-color: #c9a227;
}

/* Venue Badges */
.venue-badge {
  position: absolute;
  top: -10px;
  left: 20px;
  font-size: 11px;
  font-weight: bold;
  padding: 4px 12px;
  border-radius: 3px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.venue-badge.sala {
  background: #c9a227;
  color: #000;
}

.venue-badge.playa {
  background: #3498db;
  color: #fff;
}

.fecha {
  font-size: 14px;
  color: #888;
  margin-bottom: 12px;
  padding-top: 5px;
}

.titulo {
  font-size: 22px;
  font-weight: bold;
  color: #fff;
  margin: 0 0 8px 0;
}

.origen {
  font-weight: 400;
  color: #c9a227;
  font-size: 18px;
}

.categoria {
  font-size: 14px;
  color: #aaa;
  margin: 0;
  font-style: italic;
  text-transform: uppercase;
  letter-spacing: 0.1em;
}

/* Sub-shows (for Noche de Circo) */
.sub-shows {
  margin: 15px 0;
  padding: 15px;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 8px;
}

.sub-show {
  display: flex;
  gap: 15px;
  margin-bottom: 10px;
  align-items: flex-start;
}

.sub-show:last-child {
  margin-bottom: 0;
}

.sub-time {
  font-size: 14px;
  font-weight: bold;
  color: #c9a227;
  flex-shrink: 0;
  min-width: 45px;
}

.sub-name {
  font-size: 15px;
  color: #ddd;
}

.sub-name .origen {
  font-size: 14px;
}

/* Venue Legend */
.venue-legend {
  display: flex;
  justify-content: center;
  gap: 40px;
  margin-bottom: 50px;
  padding: 20px;
  background: #000;
  border: 1px solid #333;
  border-radius: 10px;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 12px;
}

.legend-badge {
  font-size: 12px;
  font-weight: bold;
  padding: 6px 14px;
  border-radius: 4px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.legend-badge.sala {
  background: #c9a227;
  color: #000;
}

.legend-badge.playa {
  background: #3498db;
  color: #fff;
}

.legend-text {
  font-size: 14px;
  color: #ccc;
}

.legend-link {
  font-size: 14px;
  color: #ccc;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s ease;
}

.legend-link:hover {
  color: #c9a227;
}

.map-icon {
  font-size: 16px;
  opacity: 0.6;
  transition: opacity 0.3s ease;
}

.legend-link:hover .map-icon {
  opacity: 1;
}

/* Próximas funciones section */
.proximas-section {
  margin-top: 60px;
}
.proximas-header {
  text-align: center;
  margin-bottom: 40px;
}
.proximas-title {
  font-size: 32px;
  font-weight: bold;
  color: #c9a227;
  margin: 0;
}

/* Contact CTA */
.contact-cta {
  background: #c9a227;
  padding: 40px;
  border-radius: 10px;
  text-align: center;
}

.contact-text {
  font-size: 18px;
  color: #000;
  margin: 0 0 20px 0;
  font-weight: 500;
}

.contact-btn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: #000;
  color: #fff;
  font-size: 18px;
  font-weight: bold;
  text-decoration: none;
  padding: 15px 30px;
  border-radius: 8px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  transition: all 0.3s ease;
}

.contact-btn:hover {
  background: #222;
  transform: scale(1.05);
}

.whatsapp-icon {
  font-size: 22px;
}

/* Mobile */
@media (max-width: 767px) {
  .cartelera-page {
    padding: 40px 0 60px;
  }

  .festival-title {
    font-size: 28px;
  }

  .aniversario {
    font-size: 16px;
  }

  .espectaculos-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .espectaculo-special {
    grid-column: 1;
  }

  .espectaculo-card {
    padding: 20px;
  }

  .titulo {
    font-size: 18px;
  }

  .origen {
    font-size: 15px;
  }

  .venue-legend {
    flex-direction: column;
    gap: 15px;
    align-items: flex-start;
  }

  .contact-cta {
    padding: 30px 20px;
  }

  .contact-text {
    font-size: 16px;
  }

  .contact-btn {
    font-size: 16px;
    padding: 12px 25px;
  }
}
</style>